// ============================================
// Creator State - Editor (Zustand 기반)
// ============================================

import { useCreatorStore, MAX_IMAGES as _MAX_IMAGES } from '../../../stores/creatorStore.js';

export const MAX_IMAGES = _MAX_IMAGES;

export const getCurrentEditorData = () => useCreatorStore.getState().currentEditorData;

export function resetEditorData() {
  useCreatorStore.getState().resetEditorData();
}

export function setEditorDataId(id) {
  useCreatorStore.getState().setEditorDataId(id);
}

export function setEditorDataStatus(status) {
  useCreatorStore.getState().setEditorDataStatus(status);
}

export function setCurrentEditorData(data) {
  useCreatorStore.getState().setCurrentEditorData(data);
}

// 초기 상태 저장 (수정 감지용)
export const getInitialEditorState = () => useCreatorStore.getState().initialEditorState;

export function setInitialEditorState(state) {
  useCreatorStore.getState().setInitialEditorState(state);
}
